export default "__VITE_ASSET__0eba19cd__"